import { addHours, endOfDay, startOfDay } from 'date-fns'

import { isMobile } from '@/utils/device-type'

export const LEFT_SHIFT = isMobile.value ? 0 : 15 //  rem unit
export const TIME_START = 6 // 6:00 hours

export function startOfWorkingHour(date: Date | string): Date {
  const start = startOfDay(new Date(date))
  return addHours(start, TIME_START)
}

export function endOfWorkingHour(date: Date | string): Date {
  const end = endOfDay(new Date(date))
  return addHours(end, TIME_START)
}

export function isSameWorkingDay(date1: Date | string, date2: Date | string): boolean {
  const start1 = startOfWorkingHour(date1)
  const start2 = startOfWorkingHour(date2)
  const end1 = endOfWorkingHour(date1)
  const end2 = endOfWorkingHour(date2)
  return start1.getTime() === start2.getTime() && end1.getTime() === end2.getTime()
}
